import { AxiosResponse } from 'axios';
import { api } from './base/api';
import {
  ImportRatesRequest,
  RateImportPaginationRequest
} from '../models/request';
import { Result } from '../models/common/resultResponse';
import { PaginationResponse } from '../models/common/paginationResponse';
import { IRateImportApi } from './base';
import { TimeoutRequestConfigurationEnum } from '../services/enum/TimeoutRequestConfigurationEnum';
import { DownloadFileImportSampleResponse, ImportRatesResponse, RateImportResponse } from '../models/response';

const baseRoute: string = 'RateImport';

export class RateImportApi extends IRateImportApi {
  postImportRates(
    request: ImportRatesRequest,
    file: File
  ): Promise<AxiosResponse<Result<ImportRatesResponse>>> {
    const params = new URLSearchParams(
      request as unknown as Record<string, string>
    );
    const queryString = `?${params.toString()}`;
    const url = `${baseRoute}/ImportRates${queryString}`;

    const formData = new FormData();
    formData.append('fileUpload', file);

    return api.post(url, formData, {
      timeout: TimeoutRequestConfigurationEnum.FiveMinutesInMilliseconds
    });
  }

  getSearchGrid(
    request: RateImportPaginationRequest
  ): Promise<AxiosResponse<PaginationResponse<RateImportResponse>>> {
    return api.get(`${baseRoute}/SearchGrid`, { params: request });
  }

  getErrorMessage(
    guidRateImport: string
  ): Promise<AxiosResponse<Result<any>>> {
    return api.get(`${baseRoute}/ErrorMessage`, { params: { guidRateImport } });
  }

  downloadImportFile(
    guidFileImport: string
  ): Promise<AxiosResponse<Result<any>>> {
    return api.get(`${baseRoute}/DownloadImportfile`, { params: { guidFileImport } });
  }

  getDownloadFileImportSample(): Promise<AxiosResponse<Result<DownloadFileImportSampleResponse>>> {
    return api.get(`${baseRoute}/DownloadFileImportSample`);
  }
}
